import React, { useState, useEffect } from "react";
import api, { baseURL } from "../api";
import innerBanner from "../../assets/images/banner/inner-banner.jpg";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import pdficon from "../../assets/images/icons/PDF-Icons.png";

const DeptHeadingPdf = () => {
    const { i18n, t } = useTranslation();
    const location = useLocation();
    const state = location.state || {};
    const { id } = state;
    const [activeIndex, setActiveIndex] = useState(null);
    const [data, setData] = useState([]);
    const [departmentData, setDepartmentData] = useState([]);
    const [deptData, setDeptData] = useState([]);
    const [departmentName, setDepartmentName] = useState([]);

    const fetchDeptData = async () => {
        try {
            const response = await api.get(`/department-datas?lang=${i18n.language}`);
            const filteredDepartments = response.data.filter(
                (department) =>
                    department.status === 1 &&
                    department.language_code === i18n.language
            );
            const filteredData = filteredDepartments.filter(
                (item) => String(item.y_id) === String(id)
            );
            setDeptData(filteredData);
        } catch (error) {
            console.error("Error fetching department data:", error);
        }
    };


    const fetchData = async () => {
        try {
            if (deptData.length === 0) return;
            const response = await api.get(`/department-data-heading-pdf?lang=${i18n.language}`);
            const filteredDepartments = response.data.filter(
                (department) =>
                    department.status === 1 &&
                    department.language_code === i18n.language
            );
            const filteredData = filteredDepartments.filter(
                (item) => item.y_id === deptData[0]?.y_id
            );
            setData(filteredData);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const fetchDepartmentData = async () => {
        try {
            const response = await api.get(`/public_disclosure?lang=${i18n.language}`);
            const filteredDepartments = response.data.filter(
                (department) =>
                    department.status === 1 &&
                    department.language_code === i18n.language
            );
            setDepartmentName(filteredDepartments);
            const filteredData = filteredDepartments.filter(
                (item) => String(item.p_id) === String(deptData[0]?.p_id)
            );
            setDepartmentData(filteredData);
        } catch (error) {
            console.error("Error fetching department data:", error);
        }
    };

    useEffect(() => {
        fetchDeptData();
        // eslint-disable-next-line
    }, [i18n.language]);

    useEffect(() => {
        if (deptData.length > 0) {
            fetchData();
            fetchDepartmentData();
        }
        // eslint-disable-next-line
    }, [deptData, i18n.language]);

    return (
        <div>
            <section className="page-title">
                <div
                    className="bg-layer"
                    style={{
                        backgroundImage: `url(${innerBanner})`,
                    }}
                ></div>
                <div className="line-box">
                    <div className="line-1"></div>
                    <div className="line-2"></div>
                </div>
                <div className="auto-container">
                    <div className="content-box">
                        <h1>{departmentData[0]?.department_name}</h1>
                        <ul className="bread-crumb clearfix">
                            <li>
                                <Link to="/departments">{t("departments")}</Link>
                            </li>
                            <li>
                                <span>{departmentData[0]?.department_name}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
            <section className="departments-style-two alternat-2">
                <div className="auto-container">
                    <div className="row clearfix">
                        <div className="col-lg-12 col-md-12 col-sm-12 content-side">
                            <div className="department-details-content">
                                <div className="content-one dept_leyer_1">
                                    <div className="title-box">
                                        <h3>{deptData[0]?.department_heading}</h3>
                                        <hr />
                                    </div>
                                </div>
                            </div>
                            <div className="row clearfix">
                                {data.map((download) => (
                                    <div key={download.id} className="col-md-6">
                                        <div className="department-details-content citizen-chart-pdf">
                                            <div className="content-two">
                                                <div className="download-box">
                                                    <div className="icon-box">
                                                        <img src={pdficon} alt="pdf-icon" />
                                                    </div>
                                                    <h6>{download.pdfheading}</h6>
                                                    <div className="download-btn">
                                                        <Link
                                                            to={`${baseURL}/${download.pdf}`}
                                                            rel="noreferrer"
                                                            target="_blank"
                                                            className="theme-btn btn-one"
                                                        >
                                                            {t("downloads.viewBtn")}
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default DeptHeadingPdf;
